import {
  GetAllPurchasesAPIParams,
  PurchasesCountAPIParams,
} from "@src/lib/types/purchases";
import axiosClient from "@src/utils/axios-client";
import Config from "@src/utils/api/config";

export const allPurchasesSummaryAPI = async (params?: GetAllPurchasesAPIParams) => {
  try {
    const requestParams = {
      partnerId: Config.PARTNER_ID,
      ...params,
    };

    const purchases = await axiosClient.get(
      "/purchases/summary",
      {params: requestParams}
    );

    return purchases.data || {};
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const allPurchasesRecentAPI = async (params?: GetAllPurchasesAPIParams) => {
  try {
    const requestParams = {
      partnerId: Config.PARTNER_ID,
      ...params,
    };

    const purchases = await axiosClient.get(
      "/purchases",
      {params: requestParams}
    );

    return purchases.data || {};
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const allPurchasesAPI = async (params?: GetAllPurchasesAPIParams) => {
  try {
    const requestParams = {
      page: 1,
      size: 10,
      sort: "transactionDate,desc",
      partnerId: Config.PARTNER_ID,
      ...params,
    };

    const purchases = await axiosClient.post(
      "/payment/report/getPayment",
      requestParams
    );

    return purchases.data.data || {};
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const allGoldPurchasesAPI = async (params?: GetAllPurchasesAPIParams) => {
  try {
    const requestParams = {
      page: 1,
      size: 10,
      redeemTypeID: 6,
      sort: "requestDate,desc",
      partnerId: Config.PARTNER_ID,
      ...params,
  
    };

    const purchases = await axiosClient.post(
      "/redeem/get",
      requestParams
    );

    return purchases.data || {};
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const totalPurchasesByMonths = async (params?: GetAllPurchasesAPIParams) => {
  try {
    const requestParams = {
      page: 1,
      size: 10,
      ...params,
    };

    const purchases = await axiosClient.get(
      "/payment/stats", {params: requestParams}
    );

    return purchases.data || {};
  } catch (error: any) {
    throw error.response.data.error;
  }
};

export const totalPurchasesCountAPI = async (
  params?: PurchasesCountAPIParams
) => {
  try {
    const purchases = await axiosClient.post("/payment/count", params);
    return purchases?.data?.data?.count || 0;
  } catch (error) {
    throw error;
  }
};

export const totalPurchasesCurrentMonth = async (params: any) => {
  try {
    const purchases = await axiosClient.post("/payment/stats/overview", 
      {
        partnerId: Config.PARTNER_ID,
        ...params
      });
    return purchases?.data
  } catch (error) {
    throw error;
  }
};

export const totalPurchaseSummary = async (params: any) => {
  try {
    const purchases = await axiosClient.get("/purchases/overview", 
      {params: params});
    return purchases?.data
  } catch (error) {
    throw error;
  }
};

export const totalGoldPurchasesCurrentMonth = async (params: any) => {
  try {
    const purchases = await axiosClient.post("/redeem/stats", 
      {
        redeemTypeID: 6,
        partnerId: Config.PARTNER_ID,
        ...params
      });
    return purchases?.data
  } catch (error) {
    throw error;
  }
};

export const exportPurchasesListAPI = async (
  params?: GetAllPurchasesAPIParams
) => {
  try {
    const res = await axiosClient.post(
      "/payment/report/getPayment/noPaging",
      {
        partnerId: Config.PARTNER_ID,
        ...params
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const exportGoldPurchasesListAPI = async (
  params?: GetAllPurchasesAPIParams
) => {
  try {
    const res = await axiosClient.post(
      "/redeem/get/noPaging",
      {
        redeemTypeID: 6,
        partnerId: Config.PARTNER_ID,
        ...params
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};
